function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import PropTypes from 'prop-types';
import React from 'react';
import { ModalHeader, ModalBody, ModalFooter, Button, Input, FormGroup, Label as FormLabel, Spinner } from 'reactstrap';
import Icon from '../../../common/containers/icon';
import SuggestionRow from './suggestionRow';
const GenerateChecksView = ({
  userRequest,
  onUserRequestChange,
  isGenerating,
  suggestions,
  addingId: _addingId = null,
  onGenerate,
  onAddSuggestion,
  onBack,
  pendingOperation: _pendingOperation = false
}) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement(Button, {
  color: "link",
  className: "p-0",
  onClick: onBack,
  style: {
    textDecoration: 'none',
    marginRight: 12
  }
}, /*#__PURE__*/React.createElement(Icon, {
  glyph: "arrow-left"
})), "Generate Additional Checks"), /*#__PURE__*/React.createElement(ModalBody, {
  style: {
    maxHeight: '60vh',
    overflowY: 'auto'
  }
}, /*#__PURE__*/React.createElement(FormGroup, {
  className: "mb-4"
}, /*#__PURE__*/React.createElement(FormLabel, {
  for: "userRequest"
}, "Describe what you want to check (optional)"), /*#__PURE__*/React.createElement(Input, {
  type: "textarea",
  id: "userRequest",
  placeholder: "e.g., Focus on traceability issues, or check for missing documentation...",
  value: userRequest,
  onChange: e => onUserRequestChange(e.target.value),
  rows: 3
})), /*#__PURE__*/React.createElement("div", {
  className: "text-center mb-4"
}, /*#__PURE__*/React.createElement(Button, {
  color: "primary",
  onClick: e => {
    e.stopPropagation();
    onGenerate();
  },
  disabled: isGenerating || _pendingOperation,
  "data-testid": "generate-checks-btn"
}, isGenerating ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spinner, {
  size: "sm",
  className: "me-2"
}), "Generating...") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
  glyph: "wand-magic-sparkles",
  style: {
    marginRight: 8
  }
}), "Generate")), !isGenerating && suggestions.length === 0 && /*#__PURE__*/React.createElement("p", {
  className: "text-muted mb-0 mt-3"
}, "Click Generate to get AI-powered check suggestions.")), suggestions.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("h6", {
  className: "text-muted mb-3"
}, "Suggestions (", suggestions.length, ")"), /*#__PURE__*/React.createElement("div", null, suggestions.map((suggestion, index) => {
  const suggestionId = suggestion.id || `suggestion_${index}`;
  return /*#__PURE__*/React.createElement(SuggestionRow, {
    key: suggestionId,
    suggestion: _objectSpread(_objectSpread({}, suggestion), {}, {
      id: suggestionId
    }),
    onAdd: onAddSuggestion,
    isAdding: _addingId === suggestionId
  });
})))), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
  color: "secondary",
  onClick: onBack
}, "Back to Checks")));
GenerateChecksView.propTypes = {
  userRequest: PropTypes.string.isRequired,
  onUserRequestChange: PropTypes.func.isRequired,
  isGenerating: PropTypes.bool.isRequired,
  suggestions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string
  })).isRequired,
  addingId: PropTypes.string,
  onGenerate: PropTypes.func.isRequired,
  onAddSuggestion: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  pendingOperation: PropTypes.bool
};
export default GenerateChecksView;